import { useState, useCallback } from 'react';
import { fetchCourseContentByCourseId } from '../../service/AdminService/courseService';
import { showErrorMessage } from '../../components/shared/pagination/messages';

export const useCoursesContent = () => {
    const [data, setData] = useState([]);
    const [name, setName] = useState();

    const fetchCourseContent = useCallback(async (courseId, currentPage, pageSize,isActive, searchText) => {
        if (!courseId) return;
        try {
            const queryParams = { page: currentPage, size: pageSize, active:isActive, search: searchText };
            const response = await fetchCourseContentByCourseId(courseId, queryParams);
            if (response.data.status === "SUCCESS") {
                const record = response.data?.data.content || []
                const courseName = response.data?.data?.metaDetails?.name;
                setData(record);
                setName(courseName);
                return response.data.data;
            }
        } catch (error) {
            showErrorMessage(error.message || "Failed to load content");
        }
    }, []);

    return { data, fetchCourseContent, name };
};